/**
 * Every page of theirs as its template (#788 PR2): what the browser's record
 * names a page by — `/jobs/[key]`, never `/jobs/greenhouse:123`. One list for
 * the page that sends it (`pageOf` below, through components/shell/routes.ts) and the server
 * that takes it (lib/platform/events-catalog.ts `PAGE`), so a page told by any
 * other name is refused rather than kept. tests/record.test.ts holds it equal
 * to the pages under app/.
 *
 * Imports nothing: the browser runs it.
 */
export const PAGE_ROUTES = [
  "/",
  "/jobs", "/jobs/[key]",
  "/companies", "/companies/[slug]",
  "/interviews",
  "/agent", "/agent/[thread]",
  "/me",
  "/reports/[id]",
  "/tailor/[id]",
  "/onboarding",
  "/welcome", "/login", "/register", "/forgot", "/logout", "/billing",
  "/privacy", "/terms", "/imprint",
] as const;

export type PageRoute = (typeof PAGE_ROUTES)[number];

const MATCHERS = PAGE_ROUTES.map((route) => ({
  route,
  re: new RegExp(`^${route.replace(/\[[a-z]+\]/g, "[^/]+")}/?$`),
}));

/** The template an address is shown by, or null for one that is no page of
 *  ours (and so is not recorded at all). The browser's record names a page by
 *  it (components/shell/routes.ts), and so does where an account came from
 *  (lib/platform/signup-source.ts). */
export function pageOf(pathname: string): PageRoute | null {
  if (pathname === "/" || pathname === "") return "/";
  for (const m of MATCHERS) if (m.route !== "/" && m.re.test(pathname)) return m.route;
  return null;
}
